import Vue from "vue";
import VueMeta from 'vue-meta'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VueResource from "vue-resource";
import "@/scss/style.scss";
import { Action } from "@/constants/ajax";
import { SET_GLOBAL_ERROR } from "@/constants/mutation-types";
import { MetaData }from "@/constants/meta-data"
import { DataObject } from "@/types";
import {UtilityHelper} from "@/helpers/UtilityHelper";
import {OandaHelper} from "@/helpers/OandaHelper";

Vue.use(VueResource);
Vue.use(VueMeta);
Vue.prototype.$action = Action;
Vue.prototype.$globalErrorMessage = null;

document.querySelector("html")!.setAttribute("lang", i18n.locale);

let appScript = document.querySelectorAll('[src="/app.js"]')[0];
if (appScript){
  let baseAppPath = appScript.getAttribute("src");
  let timestamp = Date.now();
  appScript.setAttribute("src", baseAppPath + "?" + timestamp);
}



const app = new Vue({
  i18n,
  router,
  store,
  render: (h: any) => h(App),
  beforeMount() {
    this.$store.dispatch("init", {});
  },
}).$mount("#app");

// @ts-ignore
window.setGlobalError = (message) => {
  app.$store.commit(SET_GLOBAL_ERROR, message);
};

if(UtilityHelper.isOandaPath()) {
  //update favicon icons
  OandaHelper.updateFavicon();

}

UtilityHelper.addGtmContent();


if ((window as any).Cypress) {
  (window as any).app = app;
  // @ts-ignore
  document.querySelector("#app").classList.add("cy-test");
}


declare global {
  interface Window { dataLayer: DataObject[]; }
}
